module.exports = __webpack_public_path__ + "img/Totes.7201ee63.png";